module.exports = __webpack_public_path__ + "static/media/YF64_5.cd2ec726.jpg";